// pages/Register/styles.js
import styled from "styled-components";
import {
	LoginWrapper,
	LoginCard,
	Logo,
	Form,
	FormGroup,
	Label,
	Input,
	ErrorMessage,
} from "../Login/styles";

// Extend the LoginWrapper to add any register-specific styles
export const RegisterWrapper = styled(LoginWrapper)``;

export const RegisterCard = styled(LoginCard)`
	max-width: 450px;
`;

export const LoginLink = styled.div`
	text-align: center;
	margin-top: ${(props) => props.theme.spacing.xl};
	font-size: ${(props) => props.theme.typography.sizes.sm};
	color: ${(props) => props.theme.colors.text.secondary};

	a {
		color: ${(props) => props.theme.colors.primary.main};
		text-decoration: none;
		font-weight: ${(props) => props.theme.typography.weights.medium};

		&:hover {
			text-decoration: underline;
		}
	}
`;

// Re-export common components
export { Form, FormGroup, Label, Input, ErrorMessage, Logo };
